import * as types from './mutation-types'

export const managedPageGetManagedPage = ({commit}, pageUuid) => {
  return Vue2.prototype.$api.active().get(`managed-pages/${pageUuid}`)
    .then((response) => {
      commit(types.MANAGED_PAGE_SET_MANAGED_PAGE, response.data)

      return response
    })
}

export const managedPageSaveManagedPage = ({commit}, data) => {
  return Vue2.prototype.$api.active().post('managed-pages', data)
    .then((response) => {
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: 'Managed Page Saved',
      })
      return response
    }).catch((error)=>{
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}

export const managedPageUpdateManagedPage = ({commit}, data) => {
  return Vue2.prototype.$api.active().put(`managed-pages/${data.uuid}`, data.data)
    .then((response) => {
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: 'Managed Page Updated',
      })
      return response
    }).catch((error)=>{
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}

export const managedPageGetManagedPages = ({commit}, query) => {

  let uri =  'managed-pages?'

  if(query.page){
    uri = `${uri}page=${query.page}&`
  }

  if(query.per_page){
    uri = `${uri}per_page=${query.per_page}&`
  }

  if(query.filter){
    uri = `${uri}filter=${query.filter}&`
  }
  if(query.search){
    uri = `${uri}search=${query.search}&`
  }

  return Vue2.prototype.$api.active().get(uri)
    .then((response) => {
      console.log(response.data)
      commit(types.MANAGED_PAGE_SET_MANAGED_PAGES, response.data)

      return response
    })
}

export const managedPageDeleteManagedPage = ({commit}, pageUuid) => {
  return Vue2.prototype.$api.active().delete(`managed-pages/${pageUuid}`)
    .then((response) => {
      commit(types.MANAGED_PAGE_SET_MANAGED_PAGE, null)
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: 'Managed Page Deleted',
      })
      return response
    }).catch((error)=>{
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}

export const managedPageDisableManagedPage = ({commit}, uuid) => {
  return Vue2.prototype.$api.active().put(`managed-pages/${uuid}`, {
    is_disabled: true,
  })
    .then((response) => {
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: 'Managed Page Disabled',
      })
      return response
    }).catch((error)=>{
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}

export const managedPageEnableManagedPage = ({commit}, uuid) => {
  return Vue2.prototype.$api.active().put(`managed-pages/${uuid}`, {
    is_disabled: false,
  })
    .then((response) => {
      commit('baseAddNotification', {
        type: 'success',
        title: 'Success',
        text: 'Managed Page Enabled',
      })
      return response
    }).catch((error)=>{
      commit('baseAddNotification', {
        type: 'error',
        title: 'Error',
        text: error.message,
      })
      throw error
    })
}

